<script lang="ts">
  import { cn } from "$lib/utils"
  import type { ButtonVariant, ButtonSize } from "./types"

  export let variant: ButtonVariant = "default"
  export let size: ButtonSize = "default"
  export let disabled = false
  export let type: "button" | "submit" | "reset" = "button"
  export let href: string | undefined = undefined
  let className = ""
  export { className as class }

  const baseStyles =
    "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"

  const variantStyles: Record<ButtonVariant, string> = {
    default: "bg-primary text-primary-content hover:bg-primary-focus",
    outline:
      "border border-input bg-background hover:bg-accent hover:text-accent-content",
    ghost: "hover:bg-accent hover:text-accent-content",
    link: "text-primary underline-offset-4 hover:underline",
  }

  const sizeStyles: Record<ButtonSize, string> = {
    default: "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3",
    lg: "h-11 rounded-md px-8",
    icon: "h-10 w-10",
  }

  $: classes = cn(
    baseStyles,
    variantStyles[variant],
    sizeStyles[size],
    disabled && "pointer-events-none opacity-50",
    className,
  )
</script>

{#if href}
  <a
    {href}
    class={classes}
    aria-disabled={disabled}
    tabindex={disabled ? -1 : undefined}
    {...$$restProps}
    on:click
    on:keydown
  >
    <slot />
  </a>
{:else}
  <button
    {type}
    class={classes}
    {disabled}
    {...$$restProps}
    on:click
    on:keydown
  >
    <slot />
  </button>
{/if}
